module.exports = "img/jornada-de-trabajo-11-09.ae9288.jpeg";